import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, Layout } from 'antd'
import SidebarContent from './SidebarContent'
import {
  toggleCollapsedSideNav,
  updateWindowWidth
} from '../../appRedux/actions/Setting'
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from '../../constants/ThemeSetting'
import App from '../../routes/index'
import {
  APP_BASE_LOCAL_URL,
  APP_STORE_WEB_URL
} from '../../Services/DataServices'
import { useRouteMatch } from 'react-router-dom'
import { useHistory } from 'react-router'
import { non_net_redirect } from '../../appRedux/actions'
import { BUS_SITE_LOCAL_IP } from '../../constants/StoreSetting'
import { checkIsWeb } from '../../appRedux/actions/MobAppFn'

const { Sider } = Layout

const Sidebar = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const match = useRouteMatch()
  const { themeType, navCollapsed, width, navStyle } = useSelector(
    ({ settings }) => settings
  )

  // const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const onToggleCollapsedNav = () => {
    dispatch(toggleCollapsedSideNav(!navCollapsed))
  }

  // useEffect(() => {
  //   const baseURL = window.location.origin
  //   const storeName = localStorage.getItem('storeName')
  //   const storeUrl = APP_STORE_WEB_URL.replace('[domain]', storeName)
  //   const fullUrl = window.location.href
  //   const redirectURL = fullUrl.replace(baseURL, storeUrl)
  //   //console.log("BASE: "+baseURL);
  //   //console.log("STORE: "+storeUrl);
  //   //console.log("REDIRECT: "+redirectURL);
  //   if (
  //     storeUrl &&
  //     APP_BASE_LOCAL_URL != baseURL &&
  //     BUS_SITE_LOCAL_IP != baseURL &&
  //     baseURL != storeUrl &&
  //     !window.location.pathname.toLocaleLowerCase().includes('loginstore') &&
  //     !window.location.pathname.toLocaleLowerCase().includes('userverify')
  //   ) {
  //     window.location.href = redirectURL
  //   }
  //   window.addEventListener('resize', () => {
  //     dispatch(updateWindowWidth(window.innerWidth))
  //   })
  // }, [dispatch])

  // useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     non_net_redirect(history, !isOnline)
  //   }

  //   return () => {
  //     mounted = false
  //   }
  // }, [isOnline])

  let drawerStyle = 'gx-collapsed-sidebar'

  if (navStyle === NAV_STYLE_FIXED) {
    drawerStyle = ''
  } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
    drawerStyle = 'gx-mini-sidebar gx-mini-custom-sidebar'
  } else if (navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
    drawerStyle = 'gx-custom-sidebar'
  } else if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
    drawerStyle = 'gx-mini-sidebar'
  } else if (navStyle === NAV_STYLE_DRAWER) {
    drawerStyle = 'gx-collapsed-sidebar'
  }
  if (
    (navStyle === NAV_STYLE_FIXED ||
      navStyle === NAV_STYLE_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) &&
    width < TAB_SIZE
  ) {
    drawerStyle = 'gx-collapsed-sidebar'
  }

  return (
    //Check for menu navigation in redux if not available calls the api and load the varible in redux
    <>
      {/* <h1>{"width : "}{width}</h1> 
    <h1>{"-TAB_SIZE:"}{TAB_SIZE}</h1> 
    <h1>{"-navStyle:"}{navStyle}</h1>
     <h1>{"-NAV_STYLE_MINI_SIDEBAR:"}{NAV_STYLE_MINI_SIDEBAR}</h1> 
       <h1>{"-NAV_STYLE_MINI_SIDEBAR:"}{NAV_STYLE_NO_HEADER_MINI_SIDEBAR}</h1>  */}
      <Sider
        className={`gx-app-sidebar ${drawerStyle} ${
          themeType !== THEME_TYPE_LITE
            ? `gx-layout-sider-dark SideBar-div ${
                checkIsWeb().exist ? '' : 'apptab-hide-menu'
              }`
            : null
        }`}
        trigger={null}
        collapsed={
          width < TAB_SIZE
            ? false
            : navStyle === NAV_STYLE_MINI_SIDEBAR ||
              navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
        }
        theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
        collapsible
      >
        {navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE ? (
          <Drawer
            className={`gx-drawer-sidebar ${
              checkIsWeb().exist ? '' : 'apptab-hide-menu'
            } ${
              themeType !== THEME_TYPE_LITE ? `gx-drawer-sidebar-dark` : null
            }`}
            placement='left'
            closable={false}
            onClose={onToggleCollapsedNav}
            visible={navCollapsed || !checkIsWeb().exist}
          >
            <SidebarContent />
          </Drawer>
        ) : (
          <SidebarContent />
        )}
      </Sider>
    </>
  )
}

export default Sidebar
